import { useSelector } from 'react-redux'

import MainLabelContainer from './MainLabelContainer/MainLabelContainer'
import MainLabelSkeleton from './MainLabelSkeleton/MainLabelSkeleton'
import { selectLandingPromosDataState } from '@betty/auth';

function MainLabel() {
  const landingPromosDataState = useSelector(selectLandingPromosDataState)


  if (landingPromosDataState.match('idle|pending')) {
    return <MainLabelSkeleton />
  }

  return <MainLabelContainer />
}

export default MainLabel
